import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext'; // AuthProvider ve useAuth import edildi
import LoginPage from './LoginPage'; // LoginPage bileşeni
import RegisterPage from './RegisterPage'; // RegisterPage bileşeni
import Dashboard from './Dashboard'; // Dashboard bileşeni
import CustomerDetailPage from './CustomerDetailPage'; // Müşteri Detay Sayfası bileşeni
import InvoicePrintPage from './InvoicePrintPage'; // Yeni İrsaliye Yazdırma Sayfası bileşeni
import { ThemeProvider, useTheme } from './ThemeContext';
import './theme.css';

// Giriş yapılmasını gerektiren rotalar için özel bileşen
const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth(); // AuthContext'ten kullanıcı durumu ve yüklenme bilgisini al

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        fontSize: '16px',
        color: '#666'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3498db',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          marginBottom: '20px'
        }}></div>
        <div>Yükleniyor...</div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // Eğer kullanıcı giriş yapmışsa çocuk bileşenleri göster, yoksa login sayfasına yönlendir
  return user ? children : <Navigate to="/login" replace />;
};

function ThemeToggleButton() {
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();
  if (location.pathname.startsWith('/invoice-print')) return null;
  return (
    <button className="theme-toggle-btn" onClick={toggleTheme}>
      {theme === 'light' ? 'Karanlık Mod' : 'Açık Mod'}
    </button>
  );
}

function App() {
  return (
    <Router> {/* Uygulamayı Router ile sarmala */}
      <AuthProvider> {/* Kimlik doğrulama bağlamını sağla */}
        <ThemeProvider>
          <ThemeToggleButton />
          <Routes> {/* Tüm rotaları tanımla */}
            {/* Public rotalar (giriş gerektirmez) */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            {/* Private rotalar (giriş gerektirir) */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/customer/:id" // Dinamik müşteri ID'si için rota
              element={
                <PrivateRoute>
                  <CustomerDetailPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/invoice-print/:invoiceId" // Yeni irsaliye yazdırma rotası
              element={
                <PrivateRoute>
                  <InvoicePrintPage />
                </PrivateRoute>
              }
            />

            {/* Varsayılan olarak giriş sayfasına yönlendir */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </ThemeProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;